import { useState, useEffect } from 'react'
import styles from './index.module.scss'
import { GlobalOutlined } from '@ant-design/icons'
import { Popover } from 'antd'
import SvgIcon from '@/components/svgIcon'
import intl from 'react-intl-universal'
import QRCode from 'qrcode.react'
import { DOWNLOAD_APP_PATH } from '@/routers/login'
import { downloadUrlAPi } from '@/services/common'
import type { DownloadResult } from '@/services/common/types'
import { appModal, isIE } from '@/utils/utils'

export default function HeaderAction({
  customizationEnable,
}: {
  customizationEnable: boolean
}) {
  const isEnUs = localStorage.getItem('lang') === 'en-US'
  const [downloadUrl, setDownloadUrl] = useState<DownloadResult>()

  // 获取app、客户端下载地址
  const getAppDownloadURL = async () => {
    try {
      const res = await downloadUrlAPi()
      setDownloadUrl(res)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getAppDownloadURL()
  }, [])

  /**
   * @desc 改变语言
   */
  const changeLang = (key) => {
    localStorage.setItem('lang', key || 'zh-CN')
    window.location.reload()
  }

  // 获取二维码容器宽度
  const getQrcodeWrapSize = () => {
    const dom = document.querySelector('.qrcode-wrap')
    if (dom && dom.clientWidth) {
      return dom.clientWidth
    }
    return 272
  }

  // 下载app、客户端
  const appDownLoad = (userAgent) => {
    let { androidUrl, iosUrl, pcClientUrl } = downloadUrl || {}
    let url
    switch (userAgent) {
      case 'android':
        url = androidUrl
        break
      case 'iphone':
        url = iosUrl
        break
      case 'browser':
        url = 'https://browser.360.cn/se/'
        break
      case 'pcClient':
        if (isIE()) {
          // 迅雷下载关闭了本页面, 但用else里的方法, IE下无法下载文件
          window.location.href = pcClientUrl
        } else {
          let _a = document.createElement('a')
          _a.download = 'PC_Client'
          _a.href = pcClientUrl
          _a.click()
        }
        return
      default:
        url = null
    }
    if (url) {
      window.open('about:blank').location.href = url
    } else {
      appModal()
    }
  }
  return <div className={`${styles.action} ${customizationEnable ? styles.custom : ''}`}>
    <div className={styles.text}>
      <GlobalOutlined />
      {
        isEnUs
          ? <span onClick={() => changeLang('zh-CN')}>中文</span>
          : <span onClick={() => changeLang('en-US')}>English</span>
      }
    </div>
    <Popover
      classNames={{
        container: styles.popover
      }}
      placement='bottomRight'
      content={
        <div className={styles.software}>
          <div className={styles.qrcode}>
            <QRCode
              value={(window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')) + DOWNLOAD_APP_PATH}
              size={getQrcodeWrapSize() * (document.documentElement.clientWidth / 1920)}
              bgColor='#ffffff'
              fgColor={'#000000'}
              level={'L'}
              renderAs={'canvas'}
            />
            {
              !customizationEnable && <div className={styles.info}>{intl.get('login.scanDownload')}</div>
            }
          </div>
          <div className={styles.list}>
            <div onClick={() => appDownLoad('android')} className={styles.item}>
              <SvgIcon name='android'></SvgIcon>
              Android
            </div>
            <div onClick={() => appDownLoad('iphone')} className={styles.item}>
              <SvgIcon name='iphone'></SvgIcon>
              iPhone
            </div>
            {
              downloadUrl?.pcClientUrl &&
              <div onClick={() => appDownLoad('pcClient')} className={styles.item}>
                <SvgIcon name='pc' />
                {intl.get('login.pcClient')}
              </div>
            }
          </div>
        </div>
      }
    >
      <div className={styles.text}>
        <SvgIcon name='downloadSoftware'></SvgIcon>
        {intl.get('login.softwareDownloads')}
      </div>
    </Popover>
  </div>
}
